import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alex-test-server/alex-booking-frontend/app/wellness-blog/_components/Blogs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alex-test-server/alex-booking-frontend/components/v3/Contact.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alex-test-server/alex-booking-frontend/components/v3/CTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alex-test-server/alex-booking-frontend/components/v3/FAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alex-test-server/alex-booking-frontend/components/v3/HeroSection.tsx");
